import { render, staticRenderFns } from "./popupDietz.vue?vue&type=template&id=979d2ae4&lang=pug&"
import script from "./popupDietz.vue?vue&type=script&lang=js&"
export * from "./popupDietz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports